<template>
  <div>
    <el-collapse-transition>
      <div class="color-palette" v-show="showColorPalette">
        <template v-if="isMobile">
          <p class="mobile-title"> 选择主题色</p>
        </template>
        <el-row type="flex" justify="center"
          @mouseenter.native="themeStatusShow"
          @mouseleave.native="themeStatusHide">
          <el-col :md="16" :xs="24">
            <el-row type="flex" justify="space-between">
              <template v-for="item in themes">
                <div :key="item.value">
                  <el-radio v-model="themeColor" :label="item.value"
                  :style="{ backgroundColor: item.color}">
                    <div class="outer-circle">
                      <i class="el-icon-check"></i>
                    </div>
                  </el-radio>
                </div>
              </template>
            </el-row>
            <template v-if="!isMobile">
              <el-row type="flex" :gutter="30" class="backdrop-row" >
                <el-col :span="8" @click.native="notCover">
                  <div class="col-item el-button--text"
                      :class="[isSelect.isNotCover ? 'selectClass' : '']">
                    <div class="triangle el-button--text" v-if="isSelect.isNotCover"></div>
                    <div class="check-mark" v-if="isSelect.isNotCover"><i class="el-icon-check"></i></div>
                    <p class="sub_word">
                      <i class='el-icon-minus'></i>&nbsp;&nbsp;无封面
                    </p>
                  </div>
                </el-col>
                <el-col :span="8" @click.native.stop="randomCover">
                  <div class="col-item el-button--text"
                    :style="{ 'background-image':'url('+ RandombackdropUrl +')'}"
                    :class="[isSelect.isRandomCover ? 'selectClass' : '']">
                    <div class="triangle el-button--text" v-if="isSelect.isRandomCover"></div>
                    <div class="check-mark" v-if="isSelect.isRandomCover"><i class="el-icon-check"></i></div>
                    <div class="dust"></div>
                    <p class="sub_word" :style="{'color': RandombackdropUrl ? '#fff' : ''}"><i class="el-icon-refresh"></i>&nbsp;&nbsp;随机封面图</p>
                  </div>
              </el-col>
                <el-col :span="8"  @click.native="customCover">
                  <div class="col-item el-button--text"
                    :class="[isSelect.isCustomCover ? 'selectClass' : '']"
                    :style="{ 'background-image':'url('+ backdropUrl +')'}">
                    <div class="triangle el-button--text" v-if="isSelect.isCustomCover"></div>
                    <div class="check-mark" v-if="isSelect.isCustomCover"><i class="el-icon-check"></i></div>
                    <div class="dust" v-if="isSelect.isCustomCover || backdropUrl"></div>
                    <p class="sub_word" :style="{'color': backdropUrl ? '#fff' : ''}" @click.stop="customCoverUpload"><i class="el-icon-upload2"></i>&nbsp;&nbsp;自定义封面图
                    </p>
                      <input
                      type="file"
                      id="upload-banner"
                      ref="banner_input"
                      name="file"
                      accept="image/png,image/jpg,image/jpeg"
                      class="el-upload__input"
                      @change="bannerFileChange">
                  </div>
                </el-col>
              </el-row>
            </template>
          </el-col>
        </el-row>
        <template v-if="isMobile">
          <div class="editing-top-modul">
            <p class="editing-underline"></p>
            <el-button @click="this.$parent.sortModules" class="button-edit-modul" type="text">隐藏/排序模块</el-button>
            <p class="mobile-title">您可以对模块进行显示/隐藏以及排序</p>
            <p class="editing-underline"></p>
            <el-button @click="this.$parent.pcEdit" class="button-edit-modul" type="text">封面图设置</el-button>
            <p class="mobile-title">您可以为主页设置个性化封面图</p>
            <p class="editing-underline"></p>
            <el-button @click="this.$parent.pcEdit" class="button-edit-modul" type="text">电脑端编辑</el-button>
            <p class="mobile-title">访问电脑网页版，获得更多高级选项</p>
          </div>
        </template>
      </div>
    </el-collapse-transition>
    <template v-if="crop_banner">
      <BannerCropper
        :image_url="crop_banner"
        :uploadBanner = "uploadBanner"
        @cancel="cancelCropBanner"
        @cropped="bannerCropped">
      </BannerCropper>
    </template>
  </div>
</template>
<script>
import { getCustomCover } from '@/api/index'
import themes from '@/config/theme'
import changeThemeColor from '@/mixins/changeThemeColor'
import ImageUtil from '@/utils/image'
import BannerCropper from '@/components/BackdropCropper/el-banner-cropper'
import md5 from 'md5'
export default {
  mixins: [changeThemeColor],
  props: {
    showColorPalette: Boolean,
    isMobile: Boolean,
    RandombackdropUrl: String,
    coverType: Number,
    customCoverUrl: String
  },
  components: {
    BannerCropper
  },
  data () {
    return {
      themes,
      themeColor: this.$store.state.config.themeColor,
      crop_banner: null,
      isSelect: {
        isNotCover: false,
        isRandomCover: false,
        isCustomCover: false
      },
      backdropUrl: null,
      num: 1
    }
  },
  mounted () {
    this.changeThemeColor(this.themeColor)
  },
  methods: {
    themeStatusShow () {
      this.$emit('isMouseenter')
    },
    themeStatusHide () {
      this.$emit('isMouseleave', this.isSelect, this.RandombackdropUrl, this.backdropUrl)
    },
    // input @change
    bannerFileChange (event) {
      const files = event.target.files
      // 判断尺寸是否达标
      if (files.length > 0) {
        let url = ImageUtil.getObjectURL(files[0])
        this.crop_banner = url
      }
    },
    // 取消
    cancelCropBanner () {
      this.crop_banner = null
    },
    uploadBanner (file) {
      const name = `acagrid/groupcontent/headbgimgs/${md5(Date.now())}.${file.type.replace('image/', '')}`
      return new Promise((resolve, reject) => {
        ImageUtil.uploadImg(file, name, (text, error) => {
          if (!error) {
            const url = `https://img.okay.do/${name}?x-oss-process=image/resize,h_260`
            console.log(url)
            resolve(url)
          }
        })
      })
    },
    // banner-cropper上传成功$emit
    bannerCropped (url) {
      this.crop_banner = null
      this.isSelect.isNotCover = false
      this.isSelect.isRandomCover = false
      this.isSelect.isCustomCover = true
      this.backdropUrl = url
      this.$emit('getUrl', url)
      getCustomCover(this.$route.params.id, {custom_cover: url}).then((res) => {})
    },
    // 无封面
    notCover () {
      this.isSelect.isNotCover = true
      this.isSelect.isRandomCover = false
      this.isSelect.isCustomCover = false
      this.$emit('NotRandombackdropUrl', null)
    },
    // 随机封面图
    randomCover () {
      if (!this.isSelect.isRandomCover) {
        this.isSelect.isNotCover = false
        this.isSelect.isRandomCover = true
        this.isSelect.isCustomCover = false
        this.$emit('modifyRondom', this.RandombackdropUrl)
      } else {
        this.isSelect.isRandomCover = true
        this.$emit('modifyRandombackdropUrl')
      }
    },
    // 自定义封面文字
    customCoverUpload () {
      var btn = document.getElementById('upload-banner')
      btn.click()
    },
    // 自定义封面div
    customCover () {
      if (this.backdropUrl) {
        this.isSelect.isNotCover = false
        this.isSelect.isRandomCover = false
        this.isSelect.isCustomCover = true
        this.$emit('modifyUpload', this.backdropUrl)
      } else {
        var btn = document.getElementById('upload-banner')
        btn.click()
      }
    }
  },
  watch: {
    themeColor: function (newValue, oldValue) {
      this.changeThemeColor(this.themeColor)
      this.$store.commit('config/changeThemeColor', this.themeColor)
    },
    customCoverUrl: function (newValue, oldValue) {
      this.backdropUrl = newValue
    },
    coverType: function (newValue, oldValue) {
      if (newValue != null) {
        switch (newValue) {
          case 2:
            this.isSelect.isNotCover = false
            this.isSelect.isRandomCover = false
            this.isSelect.isCustomCover = true
            break
          case 1:
            this.isSelect.isNotCover = false
            this.isSelect.isRandomCover = true
            this.isSelect.isCustomCover = false
            break
          case 0:
            this.isSelect.isNotCover = true
            this.isSelect.isRandomCover = false
            this.isSelect.isCustomCover = false
            break
        }
      }
    },
    RandombackdropUrl (newValue, oldValue) {
      this.RandombackdropUrl = newValue
    }
  }
}
</script>
<style lang="scss">
  @import './index.scss';
</style>



// WEBPACK FOOTER //
// src/components/ColorPalette/index.vue